import { cn } from '~/utils/cnTailwind';

const disabledClassnames = 'cursor-not-allowed opacity-50';

export const getButtonClassnames = ({
    availableCredit,
    currentRequestId,
    disabled = false,
    europacePartnerId,
    hasUnsavedChanges,
    possibilityCheckRunning,
    requestOffersPermissionDenied,
}: {
    hasUnsavedChanges: boolean;
    currentRequestId?: string;
    availableCredit: number;
    disabled?: boolean;
    possibilityCheckRunning: boolean;
    requestOffersPermissionDenied: boolean;
    europacePartnerId: string | null;
}) => {
    if (europacePartnerId === null || hasUnsavedChanges) {
        return cn(
            'flex w-full gap-4 rounded-md py-3 bg-gray-200 justify-center items-center',
            disabled && disabledClassnames,
        );
    }
    if (currentRequestId) {
        return cn(
            'flex w-full gap-4 rounded-md py-3 justify-center items-center',
            requestOffersPermissionDenied ? 'bg-gray-600' : 'bg-white',
            availableCredit >= 0 ? 'text-orange-tag' : 'text-red-600',
            availableCredit >= 0 && !possibilityCheckRunning && !disabled && 'cursor-pointer',
            disabled && disabledClassnames,
        );
    }
    let backgroundColor = 'bg-red-600';
    if (availableCredit >= 0) {
        backgroundColor = requestOffersPermissionDenied ? 'bg-gray-600' : 'bg-alert-success';
    }

    return cn(
        'flex w-full gap-4 rounded-md py-3 justify-center items-center text-white',
        backgroundColor,
        availableCredit >= 0 && !possibilityCheckRunning && !disabled && 'cursor-pointer',
        disabled && disabledClassnames,
    );
};
